const navItems = [
  {
    menu: 'Intro',
    path: 'Intro'
  },
  {
    menu: 'Education',
    path: 'Education'
  },
    {
    menu: 'Experience',
    path: 'Experience'
  },
  {
    menu: 'Publications',
    path: 'Publications'
  },
  {
    menu: 'Conferences',
    path: 'Conferences'
  },
    {
    menu: 'Achievements',
    path: 'Achievements'
  },
  {
    menu: 'Skills',
    path: 'Skills'
  },
  {
    menu: 'Projects',
    path: 'Projects'
  },
];

export default navItems;
